import React, { Component } from 'react';
import { withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import {Helmet} from "react-helmet";

import Onboarding from './Stor_Onboarding';
import Name from '../onboarding/Name';
import Account from '../onboarding/Account';
import Allergies from '../onboarding/Allergies';
import BrandsYouLike from '../onboarding/BrandsYouLike';
import Picture from '../onboarding/Picture';
import SkinConcerns from '../onboarding/SkinConcerns';
import { ChatContainerWrapper } from '../onboarding/OnboardingStyles';
import StepsHeader from '../../components/header/StepsHeader';


class Stor_OnboardingContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stage: 0,
            progress:0,
            width: document.documentElement.clientWidth,
            redirectToHome: false,
        };

        this.updateStage = this.updateStage.bind(this);
        this.redirectToHome = this.redirectToHome.bind(this);
    }

    // componentWillMount() {
    //     if (util.isMobile(navigator.userAgent) && process.env.REACT_APP_ENV === 'prod') {
    //         window.location.href = "https://sendbottles.com/r/2194?t=Hi%20Ava";
    //         this.props.history.push("/");
    //     }
    // }

    componentDidMount() {
        window.addEventListener('resize', this.handleMediaQueries.bind(this), false);
        if (this.props.location.search.includes("gift")) {
            localStorage.setItem("gift_user", true);
        }
    }
    

    componentWillUnmount() {
        // window.removeEventListener('resize', this.handleMediaQueries(this), false);
    }

    handleMediaQueries() {
        this.setState({
            width: document.documentElement.clientWidth
        });
    }

    eventTrackingStageProgress(step) {
        if ((process.env.REACT_APP_ENV === 'prod') && !localStorage.getItem("auth_token")) {
            if (step === 2) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 2 - What's Your Name?",
                    value: 1
                });
            } else if (step === 3) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 3 - Do you live in the US?",
                    value: 1
                });
            } else if (step === 4) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 4 - How old are you?",
                    value: 1
                });
            } else if (step === 5) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 5 - Are you Male or Female?",
                    value: 1
                });
            } else if (step === 6) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 6 - What is Your Ethnicity?",
                    value: 1
                });
            } else if (step === 7) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 7 - What are your primary skin concerns?",
                    value: 1
                });
            } else if (step === 8) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 8 - What products are you interested in exploring today?",
                    value: 1
                });
            } else if (step === 24) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 8-2 - Budget Question",
                    value: 1
                });
            } else if (step === 9) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 9 - Are you allergic to any of the below ingredients?",
                    value: 1
                });
            } else if (step === 10) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 10 - Could you take a selfie?",
                    value: 1
                });
            } else if (step === 11) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 11 - Q1",
                    value: 1
                });
            } else if (step === 12) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 12 - Q2",
                    value: 1
                });
            } else if (step === 13) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 13 - Q3",
                    value: 1
                });
            } else if (step === 14) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 14 - Q4",
                    value: 1
                });
            } else if (step === 15) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 15 - Q5",
                    value: 1
                });
            } else if (step === 16) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 16 - Q6",
                    value: 1
                });
            } else if (step === 17) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 17 - Q7",
                    value: 1
                });
            } else if (step === 18) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 18 - Q8",
                    value: 1
                });
            } else if (step === 19) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 19 - Q9",
                    value: 1
                });
            } else if (step === 20) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 20 - Q10",
                    value: 1
                });
            } else if (step === 21) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 21 - Q11",
                    value: 1
                });
            } else if (step === 22) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 22 - Q12",
                    value: 1
                });
            } else if (step === 23) {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 23 - Create Account",
                    value: 1
                });
            }
        }
    }


    updateStage(stage) {
        this.setState({ stage: stage });
    }
    updateProgress(progress) {
        this.setState({ progress: progress });
    }

    redirectToHome() {
        this.setState({redirectToHome: true});
    }

    render() {

        const startOfStepsWhenNotSignin =
        [
            {
                id: 'Q1',
                message: "Hello! 👋  We are so excited to get you started on your skincare journey with HelloAva. Before recommending products for you, I’d love to get to know you first. ",
                trigger: ({ value, steps }) => {
                    this.updateStage(1);
                    this.updateProgress(0);
                    return 'Q1-2';
                }
            },

            {
                id: 'Q1-2',
                delay:3000,
                message: "First, what’s your name? ",
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(2);
                    return 'A1-1';
                }

            },
            {
                id: 'A1-1',
                component: <Name answerWidthCheck={this.state.width} />,
                waitAction: true,
                trigger: 'Q2',
            },
            

            {
                id: 'Q2',
                message: 'How old are you?',
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(4);
                    this.updateProgress(2);
                    return 'A2';
                }
            },
            {
                id: 'A2',
                options: [
                    { value: '1', label: this.state.width > 813 ? "under 18" : "< 18", trigger: 'Q2-A' },
                    { value: '2', label: "19-25", trigger: 'Q2-A' },
                    { value: '3', label: "26-35", trigger: 'Q2-A' },
                    { value: '4', label: "36-50", trigger: 'Q2-A' },
                    { value: '5', label: "50+", trigger: 'Q2-A' }
                ]
            },

            {
                id: 'Q2-A',
                message: 'Thanks! And what gender pronouns do you identify with?',
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(5);
                    this.updateProgress(3);
                    return 'A2-A';
                }
            },
            {
                id: 'A2-A',
                options: [
                    { value: '1', label: "She/Her", trigger: 'Q3' },
                    { value: '2', label: "He/Him", trigger: 'Q3' },
                    { value: '4', label: "They/Them", trigger: 'Q3' },
                    { value: '3', label: "Prefer not to disclose", trigger: 'Q3' }
                ]
            },
            
            {
                id: 'Q3',
                message: 'Great! Now tell me, what are your primary skin concern(s) 🧐 ? ',
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(5);
                    this.updateProgress(3);
                    return 'A3';
                }

            },
            {
                id: 'A3',
                component: <SkinConcerns answerWidthCheck={this.state.width} />,
                waitAction: true,
                trigger: 'Q5',
            }
        ];

        const endOfStepsWhenNotSignin =
        [
            {
                id: 'Q10',
                message: "Amazing! 🥰 Thank you for going through that with us.",
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(23);
                    return 'Q10_1';
                }
            },
            
            {
                id: 'Q10_1',
                delay:3000,                
                message: "🚀 Embark on your HelloAva skincare journey by creating an account with us.",
                trigger: ({ value, steps }) => {
                    return 'A10';
                }
            },



            {
                id: 'A10',
                component: <Account answerWidthCheck={this.state.width} />,
                waitAction: true,
                trigger: ({ value, steps }) => {
                    this.updateProgress(24)
                    return 'Q11';
                }
            },
            {
                id: 'Q11',
                message: "Thank you for completing our detailed evaluation! We are calculating your skin type, regimen, and recommendations now!",
                end: true
            }
        ];

        const startOfStepsWhenSignin =
        [
            {
                id: 'Q1',
                message: "Retaking the quiz will update your existing profile and product recommendations. Does this sound good to you?",
                trigger: 'A1'

            },
            {
                id: 'A1',
                options: [
                    { value: 'yes', label: 'Yes', trigger: 'Q3' },
                    { value: 'no', label: 'No', trigger: 'Q2' }
                ]
            },
            {
                id: 'Q2',
                message: 'No problem. We will direct you to your latest profile and our recommendations.',
                end: true
            },

            {
                id: 'Q3',
                message: 'Great! Now tell me, what are your primary skin concern(s) 🧐 ? ',
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(5);
                    this.updateProgress(3);
                    return 'A3';
                }

            },
            {
                id: 'A3',
                component: <SkinConcerns answerWidthCheck={this.state.width} />,
                waitAction: true,
                trigger: 'Q5',
            }
        ];

        const startOfStepsWhenSigninHaveHairProfile =
        [
            {
                id: 'Q1',
                message: "Hi! I'm Ava, your smart skincare consultant — welcome to the future of skincare. Let me help you find the right skincare products in seconds.",
                trigger: () => {
                    this.updateStage(1);
                    return 'Q5';
                }

            }
        ];

        const endOfStepsWhenSignin =
        [
            {
                id: 'Q10',
                message: "All done! We will direct you to your latest profile and update our recommendations.",
                end: true
            }
        ];

        const stepsOfSurveyAndSelfie =
        [


            {
                id: 'Q5',
                message: 'Got it. And what’s your ideal budget for each product?',
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(24);
                    this.updateProgress(8);
                    return 'A5';
                }
            },
            { 
                id: 'A5',
                options:[
                    { value: '2', label: "<$50 - Most Affordable 🙏", trigger: 'Q6' },
                    { value: '3', label: "<$75 - Most Effective 🙌", trigger: 'Q6' },
                    { value: '4', label: "I’m open  😊", trigger: 'Q6' }
                ]
            },

            {
                id: 'Q6',
                message: 'Are you allergic🛑 🙅 to any of the below ingredients?',
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(9);
                    this.updateProgress(9);
                    return 'A6';
                }
            },

            {
                id: 'A6',
                component: <Allergies answerWidthCheck={this.state.width} />,
                waitAction: true,
                trigger: 'Q7'
            },
           
            {
                id: 'Q7',
                message: "Okay great, now let’s do a lightning⚡️ round! This will help us hone in on the best products for your skin type. It’ll take less than 2 minutes.",
                trigger: 'Q7-1'
            },

            {
                id: 'Q7-1',
                message: "Finish the sentence: On average, your forehead and cheeks appear 👀",
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(11);
                    this.updateProgress(11);        
                    return 'A7-1';
                }
            },
            {
                id: 'A7-1',
                options:[
                    { value: '1', label: "Very dry, rough, or flaky", trigger: 'Q7-2' },
                    { value: '2', label: "Somewhat dry", trigger: 'Q7-2' },
                    { value: '3', label: "Well hydrated", trigger: 'Q7-2' },
                    { value: '4', label: "Shiny or oily", trigger: 'Q7-2' }
                ]
            },


            {
                id: 'Q7-2',
                message: "Before applying moisturizer, your forehead and cheeks feel dry 🌵",
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(12);
                    this.updateProgress(12);
                    return 'A7-2';
                }
            },
            {
                id: 'A7-2',
                options:[
                    { value: '1', label: "Always", trigger: 'Q7-3' },
                    { value: '2', label: "Sometimes", trigger: 'Q7-3' },
                    { value: '3', label: "Rarely", trigger: 'Q7-3' },
                    { value: '4', label: "Never", trigger: 'Q7-3' }
                ]
            },


            {
                id: 'Q7-3',
                message: "Several hours after applying moisturizer 💦 your face appears",
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(13);
                    this.updateProgress(13);
                    return 'A7-3';
                }
            },
            {
                id: 'A7-3',
                options:[
                    { value: '1', label: "Very dry, rough, or flaky", trigger: 'Q7-4' },
                    { value: '2', label: "Smooth", trigger: 'Q7-4' },
                    { value: '3', label: "Slightly shiny", trigger: 'Q7-4' },
                    { value: '4', label: "Oily or I don't need moisturizer", trigger: 'Q7-4' }
                ]
            },
            {
                id: 'Q7-4',
                message: "Certain skincare ingredients and/or moisturizers, makeup, and cleansers cause your face to break out, itch, or burn 😖",
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(14);
                    this.updateProgress(14);
                    return 'A7-4';
                }
            },
            {
                id: 'A7-4',
                options:[
                    { value: '1', label: "Not at all", trigger: 'Q7-5' },
                    { value: '2', label: "Occasionally", trigger: 'Q7-5' },
                    { value: '3', label: "Often", trigger: 'Q7-5' },
                    { value: '4', label: "All the Time", trigger: 'Q7-5' },
                    { value: '5', label: "Unsure", trigger: 'Q7-5' }
                ]
            },


            {
                id: 'Q7-5',
                message: "Your face gets red 🥵 after moderate exercise, strong emotions like anger or eating spicy foods",
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(15);
                    this.updateProgress(15);
                    return 'A7-5';
                }
            },
            {
                id: 'A7-5',
                options:[
                    { value: '1', label: "Never", trigger: 'Q7-6' },
                    { value: '2', label: "Occasionally", trigger: 'Q7-6' },
                    { value: '3', label: "Frequently", trigger: 'Q7-6' },
                    { value: '4', label: "Always", trigger: 'Q7-6' }
                ]
            },


            {
                id: 'Q7-6',
                message: "You tend to have facial acne/pimples🚨",
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(16);
                    this.updateProgress(16);
                    return 'A7-6';
                }
            },
            {
                id: 'A7-6',
                options:[
                    { value: '1', label: "Never", trigger: 'Q7-7' },
                    { value: '2', label: "Rarely", trigger: 'Q7-7' },
                    { value: '3', label: "Sometimes", trigger: 'Q7-7' },
                    { value: '4', label: "Always", trigger: 'Q7-7' }
                ]
            },


            {
                id: 'Q7-7',
                message: "You will develop red spots or discoloration 💔 after pimples",
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(17);
                    this.updateProgress(17);
                    return 'A7-7';
                }
            },
            {
                id: 'A7-7',
                options:[
                    { value: '1', label: "Never or I don't have pimples", trigger: 'Q7-8' },
                    { value: '2', label: "Sometimes", trigger: 'Q7-8' },
                    { value: '3', label: "Often", trigger: 'Q7-8' },
                    { value: '4', label: "Always", trigger: 'Q7-8' }
                ]
            },



            {
                id: 'Q7-8',
                message: "After spending hours in the sun ☀️ your skin",
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(18);
                    this.updateProgress(18);
                    return 'A7-8';
                }
            },
            {
                id: 'A7-8',
                options:[
                    { value: '1', label: "Becomes red or sunburned  but does not get darker ", trigger: 'Q7-9' },
                    { value: '2', label: "Becomes red, but then gets darker", trigger: 'Q7-9' },
                    { value: '3', label: "Becomes much darker", trigger: 'Q7-9' },
                    { value: '4', label: "Unchanged or I already have dark skin", trigger: 'Q7-9' }
                ]
            },


            {
                id: 'Q7-9',
                message: "You have a history of hyperpigmentation 🙃 (a harmless condition where patches of skin become darker in color such as sun spots)",
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(19);
                    this.updateProgress(19);
                    return 'A7-9';
                }
            },
            {
                id: 'A7-9',
                options:[
                    { value: '1', label: "Not really", trigger: 'Q7-10' },
                    { value: '2', label: "Yes, in the past but not currently", trigger: 'Q7-10' },
                    { value: '3', label: "Yes, currently", trigger: 'Q7-10' },
                    { value: '4', label: "Yes, currently and it is noticeable from a distance", trigger: 'Q7-10' }
                ]
            },


            {
                id: 'Q7-10',
                message: "You do seasonal tanning 😎 at least 1 week per year",
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(20);
                    this.updateProgress(20);
                    return 'A7-10';
                }
            },
            
            {
                id: 'A7-10',
                options:[
                    { value: '1', label: "Not at all", trigger: 'Q7-11' },
                    { value: '2', label: "Yes, within the last 5 years", trigger: 'Q7-11' },
                    { value: '3', label: "Yes, but more than 5 years ago", trigger: 'Q7-11' },
                ]
            },


            {
                id: 'Q7-11',
                message: "The air pollution 🏙☁  where you live is",
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(21);
                    this.updateProgress(21);
                    return 'A7-11';
                }
            },
            {
                id: 'A7-11',
                options:[
                    { value: '1', label: "Minimal", trigger: 'Q7-12' },
                    { value: '2', label: "Moderate", trigger: 'Q7-12' },
                    { value: '3', label: "High", trigger: 'Q7-12' },
                    { value: '4', label: "I don't know", trigger: 'Q7-12' }
                ]
            },


            {
                id: 'Q7-12',                     
                message: "Last one! You notice facial wrinkles 🔎",
                trigger: ({ value, steps }) => {
                    this.eventTrackingStageProgress(22);
                    this.updateProgress(22);
                    return 'A7-12';
                }
            },
            {
                id: 'A7-12',
                options:[
                    { value: '1', label: "Never, not even when squinting, frowning or laughing", trigger: 'Q10' },
                    { value: '2', label: "Yes, I have some fine lines when I squint, smile, frown, or laugh", trigger: 'Q10' },
                    { value: '3', label: "Yes, a few wrinkles when squinting or frowning and fine lines at rest", trigger: 'Q10' },
                    { value: '4', label: "Yes, I have some wrinkles at rest", trigger: 'Q10' }
                ]
            }
        ];


        let steps = [];
        if (localStorage.getItem("auth_token") && !localStorage.getItem("user_has_skin_profile")) {
            steps = startOfStepsWhenSigninHaveHairProfile.concat(stepsOfSurveyAndSelfie).concat(endOfStepsWhenSignin);
        } else {
            if (localStorage.getItem("auth_token")) {
                steps = startOfStepsWhenSignin.concat(stepsOfSurveyAndSelfie).concat(endOfStepsWhenSignin);
            } else {
                steps = startOfStepsWhenNotSignin.concat(stepsOfSurveyAndSelfie).concat(endOfStepsWhenNotSignin);
            }
            
        }

        const stage = this.state.stage;

        return (
					<ChatContainerWrapper id="onboarding-container-wrapper" /*style={ this.state.width > 813 ? quizStyle : quizStyleMobile }*/>
						<Helmet>
							<title>Onboarding Survey - HelloAva</title>
							<meta name="description" content="What are your primary skin care concerns?  Answer Ava's questions to unlock your best skin care products and routine." />
						</Helmet>

                        { this.state.width > 900 ? <StepsHeader step={this.state.stage} progress={this.state.progress} /> : null }
						<Onboarding steps={ steps }  />

						{ this.state.width <= 899 ? <StepsHeader step={this.state.stage} progress={this.state.progress}/> : null }
                        
					</ChatContainerWrapper>
        );
    }
}




export default withRouter(connect()(Stor_OnboardingContainer))



// WEBPACK FOOTER //
// ./src/views/storeonboarding/Stor_OnboardingContainer.js